import { render, staticRenderFns } from "./WritingRecommend.vue?vue&type=template&id=2346d69e&scoped=true&"
import script from "./WritingRecommend.vue?vue&type=script&lang=js&"
export * from "./WritingRecommend.vue?vue&type=script&lang=js&"
import style0 from "./WritingRecommend.vue?vue&type=style&index=0&id=2346d69e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346d69e",
  null
  
)

export default component.exports